export default __webpack_public_path__ + "static/media/testimonial-user-3.32a99c95.svg";